import { render, staticRenderFns } from "./ChickPlacementAdd.vue?vue&type=template&id=84532054&scoped=true&"
import script from "./ChickPlacementAdd.vue?vue&type=script&lang=js&"
export * from "./ChickPlacementAdd.vue?vue&type=script&lang=js&"
import style0 from "./ChickPlacementAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84532054",
  null
  
)

export default component.exports